import _slicedToArray from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src953013697/src/young-platform-step/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["className", "active", "forceHover", "style", "LinkComponent", "linkIcon", "linkText", "color", "colorHover", "link", "moveIcon", "onClick"];
import React__default, { useState } from 'react';
import styled, { css } from 'styled-components';
import Text from '../text/text.component.js';
import { textColorTextHover, textColorText } from '../../theme/text-theme.js';
import '../media/Img.js';
import { Icon as Icon$1 } from '../media/Icon.js';
import { TEXT_PROPTYPES } from '../../constants/proptypes.js';
var DivLink = styled.div.withConfig({
  displayName: "actioncomponent__DivLink",
  componentId: "sc-65b74d-0"
})([""]);
var Icon = styled(Icon$1).withConfig({
  displayName: "actioncomponent__Icon",
  componentId: "sc-65b74d-1"
})(["transition:0.2s;", ";"], function (props) {
  return props.hover ? TEXT_PROPTYPES.color_text_list.includes(props.color) ? css(["", " !important"], textColorTextHover) : props.color ? "color: " + props.color : "" : TEXT_PROPTYPES.color_text_list.includes(props.color) ? css(["", " !important"], textColorText) : props.color ? "color: " + props.color : "";
});
/* TODO -> Usare i temi */

var hoverContainerCss = css(["cursor:pointer;transition:0.2s;& .icon-action{", "}"], function (props) {
  return props.moveIcon ? "transform: translateX(4px);" : "";
});
var Container = styled.div.withConfig({
  displayName: "actioncomponent__Container",
  componentId: "sc-65b74d-2"
})(["display:flex;width:max-content;& .icon-action{transition:0.2s;margin-left:4px;margin-top:auto;margin-bottom:auto;}", " ", " @media screen and (max-width:768px){}"], function (props) {
  return props.forceHover ? css(["", ""], hoverContainerCss) : "";
}, function (props) {
  return props.active && !props.forceHover ? css(["&:hover{", "}"], hoverContainerCss) : "";
});
var TextLink = styled(Text).withConfig({
  displayName: "actioncomponent__TextLink",
  componentId: "sc-65b74d-3"
})(["@media screen and (max-width:768px){font-family:EuclidCircularA-Bold,Arial;font-weight:700;font-size:16px;line-height:20px;}"]);
var Action = function Action(_ref) {
  var className = _ref.className,
    active = _ref.active,
    forceHover = _ref.forceHover,
    style = _ref.style,
    LinkComponent = _ref.LinkComponent,
    linkIcon = _ref.linkIcon,
    linkText = _ref.linkText,
    color = _ref.color,
    colorHover = _ref.colorHover,
    link = _ref.link,
    moveIcon = _ref.moveIcon,
    onClick = _ref.onClick,
    rest = _objectWithoutProperties(_ref, _excluded);
  var LinkObj = link && LinkComponent ? LinkComponent : DivLink;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Container, {
    className: className,
    forceHover: forceHover,
    active: active,
    moveIcon: moveIcon,
    style: style,
    onMouseOver: function onMouseOver() {
      setHover(true);
    },
    onMouseOut: function onMouseOut() {
      setHover(false);
    },
    onClick: onClick
  }, link && link.includes("https") ? /*#__PURE__*/React__default.createElement("a", {
    href: link,
    style: {
      textDecoration: "none"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, linkText ? /*#__PURE__*/React__default.createElement(TextLink, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "medium",
    color: active ? (forceHover || hover) && colorHover ? colorHover : color : "grey-2",
    colorHover: colorHover,
    hover: forceHover || hover,
    style: {
      marginBottom: "0px"
    }
  }, linkText) : null, linkIcon && active ? /*#__PURE__*/React__default.createElement(Icon, {
    className: "icon-action",
    icon: linkIcon,
    hover: forceHover || hover,
    color: (forceHover || hover) && colorHover ? colorHover : color,
    fontSize: "24px"
  }) : null)) : /*#__PURE__*/React__default.createElement(LinkObj, {
    to: link,
    style: {
      textDecoration: "none"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, linkText ? /*#__PURE__*/React__default.createElement(TextLink, {
    fontFamily: "euclid",
    type: "heading",
    fontSize: "medium",
    color: active ? (forceHover || hover) && colorHover ? colorHover : color : "grey-2",
    colorHover: colorHover,
    hover: forceHover || hover,
    style: {
      marginBottom: "0px"
    }
  }, linkText) : null, linkIcon && active ? /*#__PURE__*/React__default.createElement(Icon, {
    className: "icon-action",
    icon: linkIcon,
    hover: forceHover || hover,
    color: (forceHover || hover) && colorHover ? colorHover : color,
    fontSize: "24px"
  }) : null)));
};
Container.defaultProps = {
  forceHover: false,
  active: true,
  moveIcon: false
};
export { Action as default };